export const tourText = {
  emailInvite: {
    title: 'Send email invitations',
    description:
      'Type or paste a comma-separated list of emails and click Send invitations to add learners individually.',
  },
  fileImport: {
    title: 'Bulk import from a file',
    description:
      'Upload a CSV or Excel file to import many learners at once. Download the template first to get the right format.',
  },
};
